import { faCirclePause, faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';

const useAudio = (url) => {
  const [audio] = useState(new Audio(url));
  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);

  useEffect(() => {
    playing ? audio.play() : audio.pause();
  }, [playing]);

  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
    return () => {
      audio.removeEventListener('ended', () => setPlaying(false));
    };
  }, []);

  return [playing, toggle];
};

const AudioPlayer = ({ url }) => {
  const [playing, toggle] = useAudio(url);

  return (
    <div onClick={toggle} className="audio-player">
      {playing ? (
        <FontAwesomeIcon
          icon={faCirclePause}
          fontSize="30px"
          color="#ffcc00"
          cursor="pointer"
        />
      ) : (
        <FontAwesomeIcon
          icon={faCirclePlay}
          fontSize="30px"
          color="#ffcc00"
          cursor="pointer"
        />
      )}
    </div>
  );
};

export default AudioPlayer;
